import { mode } from '@chakra-ui/theme-tools';

const styles = {
  global: (props: any) => ({
    body: {
      fontFamily: 'Poppins',
      color: mode('gray.800', 'whiteAlpha.900')(props),
      bg: mode('bg.light', 'bg.dark')(props),
      lineHeight: 'base',
    },
  }),
};

export default styles;
